import React from 'react';
import type { EmployeeStatus } from '../../types/hr';
import { Badge, BadgeTone } from './Badge';
const TONE_BY_STATUS: Record<EmployeeStatus, BadgeTone> = {
  Active: 'green',
  'On Leave': 'amber',
  Onboarding: 'blue',
  Terminated: 'grey'
};
export function StatusBadge({
  status
}: {
  status: EmployeeStatus;
}) {
  return <Badge tone={TONE_BY_STATUS[status]} dot data-id="element-1161" data-mp="198vxc639iwc1">
      {status}
    </Badge>;
}